const ChartButton = ({
  loading = false,
  disabled = false,
  size = "lg",
  text,
  onClick,
  extra,
  color,
  children,
}: {
  loading?: boolean;
  disabled?: boolean;
  size?: "lg" | "md" | "sm" | "xs";
  text: string;
  onClick?: () => void;
  extra?: string;
  color?: string | number[];
  children?: React.ReactNode;
}) => {
  let sizeClass = "";
  let opacityClass = disabled || loading ? "opacity-40" : "opacity-100";

  const getColorStyles = (colorValue: string | number[]) => {
    let r: number, g: number, b: number;

    if (Array.isArray(colorValue)) {
      [r, g, b] = colorValue;
    } else {
      // Handle hex format like '#f59e0be0' or '#f59e0b'
      if (colorValue.startsWith("#")) {
        const hex = colorValue.replace("#", "");
        const isShortHex = hex.length === 3;
        const isLongHex = hex.length === 6 || hex.length === 8;

        if (isShortHex) {
          r = parseInt(hex[0] + hex[0], 16);
          g = parseInt(hex[1] + hex[1], 16);
          b = parseInt(hex[2] + hex[2], 16);
        } else if (isLongHex) {
          r = parseInt(hex.substring(0, 2), 16);
          g = parseInt(hex.substring(2, 4), 16);
          b = parseInt(hex.substring(4, 6), 16);
        } else {
          return {
            color: "rgb(55, 65, 81)", // gray-700
            backgroundColor: "rgba(243, 244, 246, 0.1)", // gray-100 with opacity
            borderColor: "rgb(107, 114, 128)", // gray-500
          };
        }
      } else {
        // Handle string format like 'rgb(r, g, b)'
        const matches = colorValue.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
        if (!matches) {
          return {
            color: "rgb(55, 65, 81)", // gray-700
            backgroundColor: "rgba(243, 244, 246, 0.1)", // gray-100 with opacity
            borderColor: "rgb(107, 114, 128)", // gray-500
          };
        }
        [, r, g, b] = matches.map(Number);
      }
    }

    return {
      color: `rgb(${r}, ${g}, ${b})`,
      backgroundColor: `rgba(${r}, ${g}, ${b}, 0.1)`,
      borderColor: `rgb(${r}, ${g}, ${b})`,
    };
  };

  const colorStyles = color
    ? getColorStyles(color)
    : {
        color: "rgb(55, 65, 81)", // gray-700
        backgroundColor: "rgba(243, 244, 246, 0.1)", // gray-100 with opacity
        borderColor: "rgb(107, 114, 128)", // gray-500
      };

  switch (size) {
    case "lg":
      sizeClass = "h-12 px-6 heading-md";
      break;
    case "md":
      sizeClass = "h-10 px-4 heading-sm";
      break;
    case "sm":
      sizeClass = "h-8 px-3  heading-sm";
      break;
    case "xs":
      sizeClass = "h-6 px-2  heading-xs";
      break;
  }

  return (
    <button
      className={`flex items-center justify-center rounded-md border px-2 py-1 font-bold uppercase ${opacityClass} ${sizeClass} ${extra}`}
      style={colorStyles}
      disabled={loading || disabled}
      onClick={onClick}
    >
      {text}
      {children}
    </button>
  );
};

export default ChartButton;
